import { Http, Url, Moment } from '@intelipost-js/secure-providers';

export default {
  exportDeliveredProviderReport({ commit }, config) {
    const { start, end } = config.filters.dateRange;

    commit('setExportLoading', true);

    const pathParams = [
      Moment(start).format('YYYY-MM-DD'),
      Moment(end).format('YYYY-MM-DD'),
    ];

    return Http.get(Url.toQueryString('api/v1/report/delivered_provider/excel', null, pathParams))
      .then(() => {
        commit('setExportLoading', false);
      })
      .catch(() => commit('setExportLoading', false));
  },
  generateDeliveredProviderTable({ commit, dispatch }, config) {
    const { start, end } = config.filters.dateRange;

    commit('setLoading', true);

    const pathParams = [
      Moment(start).format('YYYY-MM-DD'),
      Moment(end).format('YYYY-MM-DD'),
      config.pagination.limit,
      config.pagination.page,
    ];

    return Http.get(Url.toQueryString('api/v1/report/delivered_provider', null, pathParams))
      .then((res) => {
        commit('setDeliveredReportTableData', res.data.content);
        commit('setLoading', false);
        return Promise.resolve();
      })
      .then(() => dispatch('generateDeliveredProviderChart', config))
      .catch(() => commit('setLoading', false));
  },
  generateDeliveredProviderChart({ commit }, config) {
    const { start, end } = config.filters.dateRange;

    commit('setLoading', true);

    const pathParams = [
      Moment(start).format('YYYY-MM-DD'),
      Moment(end).format('YYYY-MM-DD'),
    ];

    return Http.get(Url.toQueryString('api/v1/report/chart_delivered_provider', null, pathParams))
      .then((res) => {
        commit('setDeliveredReportChartData', res.data.content);
        commit('setLoading', false);
      })
      .catch(() => commit('setLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/delivered-provider/store/actions.js